import { Box, styled, Typography } from '@mui/material';
import { STATIC_ASSETS_URL } from 'constants/api';

export const LandingWrapper = styled(Box)({
  position: 'relative',
  background: `url(${STATIC_ASSETS_URL}/img/bg_landing_page_2.jpg) no-repeat center center/cover`,
  height: '100vh',
});

export const LoadingContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  color: theme.palette.primary.main,
}));

export const MedicalDeviceLabelContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(0),
  marginRight: 'auto',
  marginLeft: 'auto',
  width: 'fit-content',
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
  // Get half of the height of the auth modal container
  '--half-auth-modal-height': 'calc(var(--auth-modal-container-height) / 2)',
  // Since the auth modal is in the middle of page, we want to place the device label
  // in the middle of the page and lower it by the height of the auth modal below the
  // middle of the page (half of its total height).
  top: 'calc(50% + var(--half-auth-modal-height))',
}));
